import { Select } from 'antd';
import { primaryButtonStyle } from 'globalStyles';
import styled, { css } from 'styled-components';

export const FormSection = styled.div`
  color: var(--dark-blue);
  background: white;
  padding-top: 12em;
  padding-left: 12em;
  position: relative;

  @media screen and (max-width: 1200px) {
    padding-top: 20em;
  }

  @media screen and (max-height: 1050px) {
    padding-top: 0;
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 1350px) {
    padding-left: 0;
    display: flex;
    justify-content: center;
  }

  a {
    color: var(--blue);
    font-weight: 500;
  }
`;

export const FormSectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormLogoImage = styled.img`
  width: 20em;
`;

export const FormHeading = styled.h5`
  color: var(--carrot-orange);
  margin-top: 1.5em;
  margin-bottom: 1em;
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  font-weight: 600;
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  max-width: 20em;
`;

export const FormContentGroup = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => props.centered && 'text-align: center; margin: 0 auto;'}
  ${(props) => props.width && `width: ${props.width};`}

  & + & {
    margin-top: 1em;
  }

  label {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 0;
  }

  a {
    margin-top: 0.5em;
    margin-left: auto;
  }
`;

export const InputContainer = styled.div`
  padding: 0.35em 0.75em;
  background-color: #f3fffe;
  border: 1px solid #aee7e0;
  ${(props) => {
    if (props.$isInvalid) {
      return css`
        background-color: #fff0eb;
        border-color: #eb624a;
        color: #524949;
      `;
    }
    return null;
  }}
  border-radius: 16px;
  display: flex;
  align-items: center;
  margin-top: 0.5em;

  input {
    margin-left: 0.5em;
    background: none;
    border: none;
    outline: none;
    flex: 1;
  }

  input:focus-visible {
    border: none;
    outline: none;
  }
`;

export const StyledButton = styled.button`
${primaryButtonStyle}
  display: block;
  font-weight: 800;
  border: none;
  padding: 0.5em 1em;
  margin-top: 2em;

  ${(props) => props.width && `width: ${props.width};`}}
  ${(props) => props.centered && 'margin-left: auto; margin-right: auto;'}
`;

export const ErrorMessage = styled.div`
  margin-top: 1em;
  display: flex;
  align-items: center;
  color: #ff3333;
  background-color: #ffc8c8;
  border: 1px solid #ff3333;
  padding: 0.5em 1em;
  border-radius: 8px;
`;

export const SuccessMessage = styled.div`
  margin-top: 1em;
  display: flex;
  align-items: center;
  color: #33cc33;
  background-color: #d6f5d6;
  border: 1px solid #33cc33;
  padding: 0.5em 1em;
  border-radius: 8px;
`;

export const ResponseText = styled.p`
  margin: 0 0 0 1em;
  flex: 1;
`;

export const BecomeCustomerText = styled.p`
  margin-top: 1em;
`;

export const LanguageSelector = styled(Select)`
  width: 90px;
  position: absolute;
  right: 10px;
  top: 10px;

  @media screen and (max-width: 1350px) {
    top: 10px;
    right: 0px;
  }

  & .ant-select-selection-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const LanguageOption = styled(Select.Option)``;
